import { BasicQueryStringUtils, LocationLike } from '@openid/appauth';

class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input: LocationLike, useHash: boolean): any {
    return super.parse(input, false);
  }
}

export default NoHashQueryStringUtils;
